import React from "react";
import "../../styles/403.css";

const Unauthorized: React.FC = () => {
  const handleGoBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/";
    }
  };

  return (
    <>
      <svg className="svg-defs" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{ display: 'none' }}>
        <defs>
          <filter id="squiggly-0">
            <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="0" />
            <feDisplacementMap id="displacement" in="SourceGraphic" in2="noise" scale="2" />
          </filter>
          <filter id="squiggly-1">
            <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="1" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" />
          </filter>
          <filter id="squiggly-2">
            <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="2" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
          </filter>
          <filter id="squiggly-3">
            <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="3" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" />
          </filter>
          <filter id="squiggly-4">
            <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="4" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="1" />
          </filter>
        </defs>
      </svg>

      <section className="error" style={{ minHeight: '100vh', width: '100vw', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
        <div style={{display: 'flex', flexDirection: 'row', width: '100%', maxWidth: 900, alignItems: 'center', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap'}}>
          <div className="stage" style={{flex: '0 0 8rem', minWidth: 200, display: 'flex', justifyContent: 'center'}}>
            <div className="key">
              <div className="key__head">
                <div className="key__eye"></div>
                <div className="key__eye"></div>
                <div className="key__mouth"></div>
              </div>
              <div className="key__body">
                <div className="key__indentation"></div>
                <div className="key__indentation"></div>
                <div className="key__indentation"></div>
                <div className="key__arm key__arm--left"></div>
                <div className="key__arm key__arm--right"></div>
              </div>
            </div>
            <div className="lock"></div>
          </div>
          <div style={{flex: '1 1 300px', minWidth: 220, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
            <h1 className="error__header" style={{fontSize: '4rem'}}>403</h1>
            <h2 className="error__header error__header--secondary" style={{fontSize: '2rem'}}>ACCESS DENIED</h2>
            <p className="error__description" style={{fontSize: '1.2rem', textAlign: 'center', margin: '1rem 0 2rem 0'}}>
              Sorry, you do not have permission to access this page.<br />
            </p>
            <button
              onClick={handleGoBack}
              style={{ width: 286, height: 78, fontSize: '1.5rem', borderRadius: 12, background: '#fdd835', color: '#111', fontWeight: 700, border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', marginBottom: 16, cursor: 'pointer', maxWidth: '100%' }}
            >
              Go Back
            </button>
    
          </div>
        </div>
      </section>
      <style>{`
        @media (max-width: 700px) {
          .error {
            padding: 2rem 0.5rem;
          }
          .error__header {
            font-size: 2.5rem !important;
          }
          .error__header--secondary {
            font-size: 1.2rem !important;
          }
          .stage {
            height: 10rem !important;
            width: 5rem !important;
          }
        }
        @media (max-width: 500px) {
          .error {
            padding: 1rem 0.2rem;
          }
          .error__description {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </>
  );
};

export default Unauthorized;